import { valueConverter } from 'aurelia';

/**
 * Lottery balls are coloured by range. One colour per decade, which is also
 * one row of the board: cool colours for Heads (1-40), warm for Tails (41-80).
 */
export const DECADE_COLORS = ['#2e7bd6', '#1fa3a3', '#3ba55d', '#8cc63f', '#ffc72c', '#f0862b', '#e2432b', '#d6408e'];

export function ballColor(n: number): string {
  return DECADE_COLORS[Math.max(0, Math.min(7, Math.floor((n - 1) / 10)))];
}

@valueConverter('ballColor')
export class BallColorValueConverter {
  toView(n: number): string {
    return ballColor(n);
  }
}
